import React from "react";
import { Link } from "react-router-dom";

import Button from "../buttons/Button";

const truncateWords = (text, limit = 25) => {
  if (!text) return "";
  const words = text.trim().split(/\s+/);
  if (words.length <= limit) return text;
  return words.slice(0, limit).join(" ") + "...";
};

const ProgramsCards = ({ item }) => {
  const truncatedDescription = truncateWords(item.description, item?.wordLimit || 25);

  return (
    <div className="h-full py-4">
      <div className="mx-auto shadow-md flex flex-col justify-between h-full px-4 pb-6 pt-4 w-[300px] bg-white rounded-lg border border-gray-100">
        <div>
          <div className="h-[260px] w-[260px] mx-auto flex items-center justify-center overflow-hidden">
            <img src={item.image} alt="" className="saturate-150 max-h-full object-cover" />
          </div>
          <div className="mx-3">
            <div className="primary-color mt-4 text-lg font-bold min-h-[56px] flex items-center leading-snug">
              {item.title}
            </div>
            <div className="mt-3 text-justify text-sm leading-relaxed text-[#696969]">
              {truncatedDescription}
            </div>
          </div>
        </div>
        <div className="mx-3 mt-4">
          <Link
            to={item?.readMore}
            onClick={() => {
              window.scroll(0, 0);
            }}
          >
            <Button btn="READ MORE" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProgramsCards;
